import { FC, useEffect } from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

type UseVersionHistoryBag = {
  isOpen: boolean;
  openDrawer: () => void;
  closeDrawer: () => void;
};

export const useVersionHistoryDrawer = (
  versionHistory: boolean
): UseVersionHistoryBag => {
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (!versionHistory) {
      return;
    }
    onOpen();
  }, [versionHistory, onOpen]);

  const handleOpenDrawer = () => {
    const searchParams = new URLSearchParams({ versionHistory: 'true' });

    navigate({ search: searchParams.toString() }, { replace: true });
  };
  const handleCloseDrawer = () => {
    onClose();
    navigate(
      {
        search: undefined,
      },
      { replace: true }
    );
  };

  return {
    isOpen,
    openDrawer: handleOpenDrawer,
    closeDrawer: handleCloseDrawer,
  };
};

export const VersionHistoryDrawer: FC<UseVersionHistoryBag> = ({
  isOpen,
  closeDrawer,
  children,
}) => {
  return (
    <Drawer
      size="xl"
      isOpen={isOpen}
      onEsc={closeDrawer}
      onClose={closeDrawer}
      onOverlayClick={closeDrawer}
    >
      <DrawerOverlay>
        <DrawerContent>
          <DrawerHeader fontSize="3xl">Version History</DrawerHeader>
          <DrawerCloseButton onClick={closeDrawer} />
          <DrawerBody>{children}</DrawerBody>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  );
};
